<template>
  <div class="home" v-cloak>

   <div class="search" :style="{top:top + 12   + 'px',zIndex:'99999999999999999'}">

      <div class="logo">
        <div class="nav_logo" v-if="searchShow">
          <img src="../assets/image/searchlogo.png" alt=""    @click="newsPage()">
        </div>
        <div class="searchI">
          <input type="text" class="myinput" v-model="values" @focus.prevent="focus" @blur.prevent="blur" @keyup.13="searchTab">
          <div class="search_icon" @click="searchTab">
            <img src="../assets/image/search.png" alt="">
          </div>
          <div class="recommend" v-if="searchBottom">
            <div class="ul">
              <div class="li" v-for="(item,index) in referral" :key="index" @mousedown.prevent="searchEvent(item.title,item.types)"
                @click.stop="searchEvent(item.title,item.types)">
                <span style="margin-left: 15px;" v-if="item.types== 1 && item.label_name">展厅</span>
                <span style="margin-left: 15px;" v-if="item.types== 2">投票</span>
                <span style="margin-left: 15px;" v-if="item.types== 3">新闻</span>
                <span :class="{mar:item.tpe}">{{item.title}}</span>
                <span style="float: right;margin-right: 30px;">

                  <span :class="{success:item.label_name == '最新',fail:item.label_name == '热门'}">{{item.label_name}}</span>
                  <span v-if="item.type == 4" @mousedown.stop="closeHist(item.title)" style="cursor: pointer;"
                    @click.stop="closeHist(item.title)">{{$t('language.Delete')}}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
	  </div>
    </div>


    <div class="homeBg">
      <div class="logos" v-if="searchShow">
            <img src="../assets/image/pip.png" alt="">
          </div>
      <swiper class="myswiper swiper-no-swiping" :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-slide " v-for="(item,index) in carouselArrs" :key="index" :style="{backgroundImage:'url('+ item.pc_path +')',backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
          @click.native="carouselEvent(index)">
        </swiper-slide>
        <!-- 分页器 -->
        <div class="hp_scroll" ref="hpScroll" :style="{background:color,opacity:opacity}" style="height: 25%;">
        </div>
      </swiper>
      <div class="footer_bottom" ref="footerB">
        <div class="swipers" :style="{zIndex:'99999999999'}">
          <div class="sw">
            <div class="top">
              <div class="right"></div>
              <div class="left"></div>
            </div>
            <div class="autoPlay">
              <swiper class="swiper"  :options="swiperOptionO" ref="Swiper">
                <swiper-slide v-for="(item,index) in carouselArr" :key="index" class="swiper-slides swiper-slide">
                  <div style="width: 186px;height: 122px;" @click="exhibitionEvent(item.id)">
                    <img :src="item.img_src" style="width: 186px;height: 88px;" alt="">
                    <div class="titles">
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="swiper-button-next swp1"></div>
            <div class="swiper-button-prev swp1"></div>
            <div style="height: auto;background: #FFFFFF;padding-top: 30px;">
              <div class="information" v-if="inforShow">
                <div class="topDiv">
                  <p>{{$t('language.Guide')}}</p>
                </div>
                <div class="inforContent">
                  <div class="inforLeft">
                    <div class="inforList" v-for="(item,index) in workes" :key="index" @click="inforEvent(item)">
                      <div class="inforImage">
                        <img :src="item.image.file_path" alt="">
                      </div>
                      <div class="titleinfor">
                        <p>{{item.title}}</p>
                      </div>
                      <div class="inforTitle">
                        <p>{{item.index_summary}}</p>
                      </div>
                    </div>
                  </div>
                    <div class="clear"></div>

                 <div class="inforRight" v-if="advertisement.pc_file_type == 'image'">
                    <img :src="advertisement.pc_file_path" alt="">
                  </div>
                  <div v-else    class="inforRight">
                   <!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player> -->
                   <video poster="../assets/image/video.png" width="100%" height="100%" controls="controls"  :src="advertisement.pc_file_path"></video>
                  </div>
                </div>
              </div>

              <div class="footer" :style="{background:'url('+imageUrl+')',backgroundSize:'cover'}">
                <div class="cen">
                  <span>{{$t('language.about')}}</span>
                </div>
                <div class="introduction" v-html="about">

                </div>
              </div>

              <div style="width: 100%;min-height: 120px;">
                <div class="hezuo">
                  <span>{{$t('language.Partners')}}</span>
                </div>
                <swiper class="swiper class" :options="swiperOptionK" style="margin-top:15px ;" ref="Swiper">
                  <swiper-slide v-for="(item,index) in partner" :key="index" class="swiper-slides swiper-slide">
                    <a class="imageBox" target="_blank">
                      <img :src="item.file_path" alt="">
                    </a>
                  </swiper-slide>
                </swiper>
              </div>

              <div style="height: 120px;"></div>
              <div class="footerTitle" >
                <div class="title_center">
					<div class="listB" style="padding-top: 4px;padding-bottom: 4px;">
						<a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 59px;'><img src='../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a>
					</div>
                  <div class="listB">
                    <span>{{$t('language.address_b')}}：{{info.address}}</span>
                  </div>
                  <div class="listB">
                    <span>{{$t('language.emails')}}:{{info.email}}</span>
                  </div>
                  <div class="listB">
                    <a href="https://beian.miit.gov.cn/" style="color: rgba(0, 0, 0, .7);text-decoration: none;" target="_blank">
                      <span>ICP备：晋ICP备18006634号-1</span>
                    </a>
                  </div>

                </div>
              </div>

              <fiex :shows="fixed" :fatherMethod="goTop"></fiex>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import htm from './htm.vue'
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import fiex from '../components/fiex.vue'
  var num = 7;
  var vm = null;
  export default {
    components: {
      fiex,
      htm
    },

    data() {
      return {
        fixed: false,
		videoShow:false,
		controls:true,
        // 合作伙伴左右滑动
        swiperOptionK: {
          slidesPerView: 7,
          spaceBetween: 20,
          notNextTick: true,
          //设置点击箭头
          //自动轮播
          loop: false,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        },
        swiperOptionO: {
          slidesPerView: 8,
          notNextTick: true,
          //设置点击箭头
          navigation: {
            nextEl: '.right',
            prevEl: '.left',
          },

          //自动轮播
          autoplay:true,
          loop: false,
          loopedSlides :10,
           loopFillGroupWithBlank: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper

        },

        searchShow: true,
        opacity: 1,
        color: 'transparent',
        playerOptions: {
          playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "",
            src: '' //url地址
          }],
          poster: "", //你的封面地址
          // width:document.documentElement.clientWidth,
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true, //当前时间和持续时间的分隔符
            durationDisplay: true, //显示持续时间
            remainingTimeDisplay: false, //是否显示剩余时间功能
            fullscreenToggle: true //全屏按钮
          }
        },
        top: 70,
        partner: [],
        inforShow:true,
        imageUrl: require('../assets/image/bout.png'),
        carouselArrs: [],
        referral: [],
        newsOne: {},
        newsTwo: {},
        newsThree: {},
        info: {}, // 底部配置信息
        advertisement: {},
        carouselArr: [],
        i: 0,
        searchBottom: false,
        historyList: [],
        values: '',
        swiperOption: {
          //设置点击箭头
          navigation: {
            nextEl: '.swiper-button-next.swp1',
            prevEl: '.swiper-button-prev.swp1',
          },
          //自动轮播
          autoplay: 1000,
          effect: 'fade',
          //开启循环模式
          loop: true
        },

        swiperOptions: {
          //设置点击箭头
          navigation: {
            nextEl: '.right',
            prevEl: '.left',
          },
          //自动轮播
          autoplay: 3000,
          //开启循环模式
          loop: true

        },


        news: {},
        about: '',
        workes: []
      }
    },
    inject: ['reload'],
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      }
    },
    created() {
      // setInterval(() => {
      //   console.log(this); //this是 vue 对象
      // }, 1000) //自动循环播放图片 1秒播放一次
	  console.log(this.$route,'23123123')


      vm = this;
      this.getScroll()
      window.addEventListener('resize', () => this.getScroll(), false)
      this.$fetch('/index/index').then(res => {
        this.about = res.data.about;
        this.carouselArrs = res.data.banner;
        this.carouselArr = res.data.exhibition_display_category;
        this.workes = res.data.works;

         if(this.advertisement.length <= 0 && this.workes.length <= 0){
           this.inforShow = false;
         }else{
           this.inforShow = true;
         }

        // var obj = {};
        // obj.title = res.data.news[0].title;
        // obj.content = res.data.news[0].content.substr(0, 60) + '...';
        // obj.news_id = res.data.news[0].news_id;
        // obj.create_time = res.data.news[0].create_time
        // this.newsOne = obj;
        // var obj = {};
        // obj.title = res.data.news[1].title;
        // obj.content = res.data.news[1].content.substr(0, 60) + '...';
        // obj.news_id = res.data.news[1].news_id;
        // obj.create_time = res.data.news[1].create_time
        // this.newsTwo = obj;
        // var obj = {};
        // obj.title = res.data.news[2].title;
        // obj.content = res.data.news[2].content.substr(0, 60) + '...';
        // obj.news_id = res.data.news[2].news_id;
        // obj.create_time = res.data.news[2].create_time
        // this.newsThree = obj;

        this.partner = res.data.partner;
      })
     setTimeout(()=>{
       this.$fetch('/index/info').then(res => {
         this.info = res.data;
       })
     },1000)

      var data = {
        location: 1
      }
      console.log(data);
      this.$fetch('/ad/fixed', data).then(res => {
        this.advertisement = res.data;
        this.playerOptions.sources[0].src = this.advertisement.pc_file_path
      })
    },
    mounted() {
      let that = this;
      this.$refs.hpScroll.addEventListener('scroll', function() {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || that.$refs.hpScroll.scrollTop ||
          window.pageYOffset;
        that.$refs.hpScroll.scrollTop = scrollTop;
        if (scrollTop > 500) {
		  that.videoShow = false;
          that.top = 30

          that.fixed = true;
          that.searchShow = false;

        } else {
			that.videoShow = false;
          that.top = 200
          that.searchShow = true;
        }
		console.log(that.videoShow)
      })
      this.$refs.footerB.addEventListener('scroll', function() {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || that.$refs.footerB.scrollTop ||
          window.pageYOffset;
		  console.log(scrollTop)
        if (scrollTop > 280) {
          that.top = 38
		  that.videoShow = false;
          that.fixed = true;
          that.searchShow = false;
        } else {
          that.fixed = false;
		  that.videoShow = false;
          that.top = 70
          that.searchShow = true;
        }
      })

    },
    methods: {
      goPage(){
        window.location.href = 'https://beian.miit.gov.cn/'
      },
		dataEvent(){
			let newdata = new Date();
			let startDate = new Date('2021-08-30 10:00:00');
			let newTime = Date.parse(newdata);
			let startTime = Date.parse(startDate);
			console.log(startTime <= newTime);
			return startTime <= newTime
		},
      inforEvent(item) {
        this.$router.push({
          path:'/newsDetails?id=' + item.news_id
        })
        // this.$fetch('/Hall/displayCategoryList').then(res => {
        //   if (res.code == 201) {
        //     this.$router.push({
        //       path: '/exhibition'
        //     })
        //   } else {
        //     if (type == 'multiple') {
        //       this.$router.push({
        //         path: '/halldetail',
        //         query: {
        //           display_category_id: displayId,
        //           exhibition_category_id: exhibition_category_id,
        //           exhibition_apply_id: id,
        //           type: "home",
        //           organization_name:organization_name
        //         }
        //       })
        //     } else {
        //       this.$router.push({
        //         path: '/halldetail',
        //         query: {
        //           display_category_id: displayId,
        //           exhibition_category_id: exhibition_category_id,
        //           photographer_id: photographer_id,
        //           type: "home"
        //         }
        //       })
        //     }
        //   }
        // })
      },
      swiperEvent(index) {
        console.log(index)
      },
      nextHandler(e) {
        console.log(e);
        this.currentIndex++;
        //更改图片地址
        if (this.currentIndex == 3) { //js的if判断语句
          this.currentIndex = 0;
        }
      },

      prevHandler(e) {
        console.log(e);
        this.currentIndex--;
        //更改图片地址
        if (this.currentIndex == 0) { //js的if判断语句
          this.currentIndex = 3;
        }
      },
      imgHandler(e) { //每一个事件都有一个event对象, 冒泡阻止默认事件学的
        console.log(e.target); //当前目标对象 <img src="img/1.jpg" alt>
        console.log(this); //实例化里面的对象this 指的都是当前实例化对象
      },
      imgHandler(e) { //每一个事件都有一个event对象, 冒泡阻止默认事件学的
        console.log(e.target); //当前目标对象 <img src="img/1.jpg" alt>
        console.log(this); //实例化里面的对象this 指的都是当前实例化对象
      },




      gotoDetail() {
        this.$message.error('1')
      },
      handleClickSlide(index) {
        alert(index)
      },
      goTop() {
        this.$refs.footerB.scrollTop = 0;
        this.$refs.hpScroll.scrollTop = 0;
      },
      getScroll() {
        var witch = document.documentElement.clientWidth;

        if (witch > 1700) {
          this.$set(this.swiperOptionO, "slidesPerView", 7)
        }
        if (witch < 1580) {
          this.$set(this.swiperOptionO, "slidesPerView", 5.5)
        } else {
          this.$set(this.swiperOptionO, "slidesPerView", 8)
        }

      },
      exhibitionEvent(id) {
        return
        var show = true;
        this.$fetch('/Hall/displayCategoryList').then(res => {
          if (res.code == 201) {
            this.$router.push({
              path: '/exhibition'
            })
          } else {
            this.$router.push({
              path: '/halldetail',
              query: {
                display_category_id: id
              }
            })
          }
        })


      },
      exhibitionDetail(item, index) {
        this.$router.push({
          path: '/halldetail',
          query: {
            display_category_id: item.id,
            title: item.title
          }
        })

      },
      searchTab() {
        if (!this.historyList.includes(this.vlaues)) {
          this.historyList.unshift(this.values);
          var newArr = [];
          for (var i = 0; i < this.historyList.length; i++) {
            if (newArr.indexOf(this.historyList[i]) == -1) {
              newArr.push(this.historyList[i]);
            }
          }
          localStorage.setItem("historyList", JSON.stringify(newArr));
        } else {

          localStorage.setItem("historyList", JSON.stringify(this.historyList));
        }
        this.$router.push({
          path: '/search',
          query: {
            msg: this.values,
            types: 1
          }
        })

      },
      newsOneEvent(item) {
        this.$router.push({
          path: '/newsDetails',
          query: {
            id: item.news_id
          }
        })
      },
      searchEvent(data, type) {
        this.$router.push({
          path: '/search',
          query: {
            msg: data,
            types: type
          }
        })
      },
      focus() {

        if (JSON.parse(localStorage.getItem("historyList"))) {
          this.historyList = JSON.parse(localStorage.getItem("historyList"));
        }
        var arr = [];
        for (var i = 0; i < this.historyList.length; i++) {
          var obj = {};
          obj.title = this.historyList[i];
          obj.type = 4;
          obj.types = 1;
          obj.tpe = true;
          arr.push(obj);
        }
        var result = [];
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
          if (!obj[arr[i].title]) {
            result.push(arr[i]);
            obj[arr[i].title] = true;
          }
        }
        console.log(result);
        this.$fetch('/search/referral').then(res => {
          this.referral = res.data.concat(result);
        })
        this.searchBottom = true;
      },
      // 删除历史记录
      closeHist(name) {
        this.searchBottom = true;
        var historyList = window.localStorage.getItem('historyList');
        historyList = JSON.parse(historyList);
        for (var i = 0; i < historyList.length; i++) {
          if (name == historyList[i]) {
            if (historyList.length == 1) {
              window.localStorage.setItem('historyList', '[]')
            }
          } else {
            if (!arr) {
              var arr = [];
            }
            arr.push(historyList[i]);
            console.log(arr);
            console.log('');
            window.localStorage.setItem('historyList', JSON.stringify(arr))
          }
        }
      },
      blur() {
        this.searchBottom = false;
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/home.css");
</style>



// WEBPACK FOOTER //
// src/pages/home.vue